var _g, _g2, _rect, _rect2, _g3, _g4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelListinImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 214,
    viewBox: "0 0 230 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_2161_21802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.805 144.804C148.719 140.89 151.823 136.244 153.942 131.13C156.06 126.016 157.15 120.535 157.15 115C157.15 109.464 156.06 103.983 153.942 98.8696C151.823 93.7557 148.719 89.1092 144.805 85.1952C140.891 81.2812 136.244 78.1764 131.13 76.0582C126.016 73.94 120.535 72.8497 115 72.8497C109.465 72.8497 103.984 73.94 98.8699 76.0582C93.756 78.1764 89.1094 81.2812 85.1955 85.1952L115 115L144.805 144.804Z",
    fill: "#FFDF6F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter1_f_2161_21802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.1954 85.1957C81.2815 89.1097 78.1767 93.7563 76.0585 98.8702C73.9402 103.984 72.85 109.465 72.85 115C72.85 120.536 73.9402 126.017 76.0585 131.13C78.1767 136.244 81.2815 140.891 85.1955 144.805C89.1094 148.719 93.756 151.824 98.8699 153.942C103.984 156.06 109.465 157.15 115 157.15C120.535 157.15 126.016 156.06 131.13 153.942C136.244 151.824 140.891 148.719 144.805 144.805L115 115L85.1954 85.1957Z",
    fill: "#FFA800"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.8091,
    y: 79.8086,
    width: 70.3818,
    height: 70.3818,
    rx: 12,
    fill: "#1D2025"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    transform: "translate(91 91)",
    fill: "url(#pattern0)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2161_21802)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M129.5 115C129.5 112.248 128.717 109.554 127.243 107.231C125.768 104.907 123.663 103.052 121.174 101.88",
    stroke: "#FFA800",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M129.5 115C129.5 111.312 128.095 107.763 125.57 105.074",
    stroke: "#FFA800",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M129.5 115C129.5 113.172 129.155 111.361 128.482 109.662",
    stroke: "#FFA800",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 115C128 114.973 128 114.946 128 114.918",
    stroke: "#FFA800",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2161_21802)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M107.75 102.442C105.367 103.817 103.425 105.843 102.15 108.281C100.875 110.72 100.321 113.47 100.551 116.212",
    stroke: "#FFA800",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M107.75 102.442C104.556 104.286 102.185 107.277 101.119 110.808",
    stroke: "#FFA800",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M107.75 102.442C106.167 103.355 104.772 104.56 103.636 105.992",
    stroke: "#FFA800",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5 103.741C108.476 103.754 108.453 103.768 108.429 103.782",
    stroke: "#FFA800",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2161_21802)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M107.75 127.558C110.133 128.934 112.858 129.603 115.607 129.488C118.356 129.373 121.016 128.478 123.275 126.908",
    stroke: "#FFA800",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M107.75 127.558C110.944 129.402 114.72 129.96 118.311 129.118",
    stroke: "#FFA800",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M107.75 127.558C109.333 128.472 111.074 129.078 112.882 129.345",
    stroke: "#FFA800",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5 126.259C108.524 126.273 108.547 126.286 108.571 126.3",
    stroke: "#FFA800",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2161_21802",
    x: 13.1953,
    y: 0.851562,
    width: 215.955,
    height: 215.953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36,
    result: "effect1_foregroundBlur_2161_21802"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2161_21802",
    x: 0.850098,
    y: 13.1953,
    width: 215.955,
    height: 215.953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36,
    result: "effect1_foregroundBlur_2161_21802"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2161_21802"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2161_21802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(99 99)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2161_21802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(109.144 136.855) rotate(-120)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2161_21802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(136.856 109.145) rotate(120)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2161_21802",
    width: 1,
    height: 1,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAQSURBVHgBAQUA+v8AAAAAAAAFAAFkeJU4AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelListinImg);
export default __webpack_public_path__ + "static/media/cancelListinImg.55c02acadb556aa37d489fec78fdce0c.svg";
export { ForwardRef as ReactComponent };